<script>
import Layout from "@layouts/auth";
import appConfig from "@src/app.config";

export default {
  page: {
    title: "Log in",
    meta: [
      {
        name: "description",
        content: `Log in to ${appConfig.title}`
      }
    ]
  },
  components: {
    Layout
  },
  data() {
    return {
      appConfig: appConfig,
      email: "",
      password: "",
      authError: null,
      tryingToLogIn: false,
      isAuthError: false
    };
  },
  computed: {
    loggingIn() {
      return this.$store.state.auth.status.loggingIn;
    },
    alert() {
      return this.$store.state.alert;
    }
  },
  created() {
    this.$store.dispatch("alert/clear");
    this.$store.dispatch("filter/clear");
  },
  methods: {
    tryToLogIn() {
      this.submitted = true;
      const { email, password } = this;
      if (email && password) {
        this.$store.dispatch("auth/login", {
          email,
          password
        });
        this.$store.dispatch("alert/clear");
      }
    },
    closeAlert() {
      this.$store.dispatch("alert/clear");
    }
  }
};
</script>

<template>
  <Layout>
    <div class="row justify-content-center">
      <div class="col-md-12 col-lg-6 col-xl-5">
        <div class="card">
          <div class="card-body p-4">
            <div class="text-center w-75 m-auto">
              <a href="/">
                <span
                  ><img
                    src="@assets/images/logo-dark.png"
                    class="logo m-auto"
                    alt=""
                    height="50"
                /></span>
              </a>
              <p class="text-muted mb-3 mt-3">
                Acesse o portal com seu <strong>e-mail</strong> e
                <strong>senha</strong>
              </p>
            </div>

            <b-form @submit.prevent="tryToLogIn">
              <b-form-group
                id="input-group-1"
                label="E-mail"
                label-for="input-1"
              >
                <b-form-input
                  id="input-1"
                  v-model="email"
                  type="text"
                  required
                ></b-form-input>
              </b-form-group>

              <b-form-group
                id="input-group-2"
                label="Senha"
                label-for="input-2"
              >
                <b-form-input
                  id="input-2"
                  v-model="password"
                  type="password"
                  autocomplete="off"
                  required
                ></b-form-input>
              </b-form-group>
              <div class="row">
                <div class="col-12 text-center">
                  <p>
                    <router-link tag="a" to="/EsqueceuSenha" class="ml-1"
                      >Esqueceu sua senha?</router-link
                    >
                  </p>
                </div>
                <!-- end col -->
              </div>
              <b-alert
                variant="danger"
                dismissible
                :show="alert.show"
                @dismissed="closeAlert"
              >
                {{ alert.message }}
              </b-alert>

              <b-form-group id="button-group" class="mt-2">
                <b-button type="submit" variant="primary" class="btn-block"
                  >Entrar</b-button
                >
              </b-form-group>
            </b-form>
          </div>
          <!-- end card-body -->
        </div>
        <!-- end card -->
        <div class="row">
          <div class="col-12 text-center">
            <p class="text-muted">
              Não possui acesso? Entre em contato
              <a class="link" :href="'mailto:' + appConfig.contact">
                {{ appConfig.contact }}
              </a>
            </p>
          </div>
          <!-- end col -->
        </div>
        <!-- end row -->
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->
  </Layout>
</template>

<style lang="scss" module></style>
